import { render, staticRenderFns } from "./searchForUser.vue?vue&type=template&id=31bfd64c"
import script from "./searchForUser.vue?vue&type=script&lang=js"
export * from "./searchForUser.vue?vue&type=script&lang=js"
import style0 from "./searchForUser.vue?vue&type=style&index=0&id=31bfd64c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports